module.exports = __webpack_public_path__ + "static/007-2368383ce23b8b73011e50cef13eadc5.jpg";